export default __webpack_public_path__ + "static/media/dangerFlag.2ff66401.png";